































































import {
  Component,
  Prop,
  Watch,
  Vue as VueDecorator,
} from "vue-property-decorator";
import { formatTime } from "@/utils/DateFormatter";
import { firestore } from "firebase/app";

import {
  formatDateShort,
  dateFromIsoString,
  toDatePickerFormat,
} from "@/utils/DateFormatter";

@Component
export default class DateAndTimePickerComponent extends VueDecorator {
  @Prop() datePickerLabel!: string;
  @Prop() timePickerLabel!: string;

  @Prop({ default: null }) minDate!: firebase.firestore.Timestamp | null;
  @Prop({ default: null }) maxDate!: firebase.firestore.Timestamp | null;
  @Prop({ default: false }) readonly!: boolean;
  @Prop({ default: "" }) textFieldStyle!: string;

  isPickerOpen = false;

  selectedDate: Date | null = null;
  selectedHoursAndMinutes = "";

  onNewDatePicked(input: string) {
    this.isPickerOpen = false;
    this.selectedDate = dateFromIsoString(input);
  }

  setDate(date: Date | null) {
    if (this.date?.getTime() === date?.getTime()) {
      return;
    }

    this.selectedDate = date;
    this.selectedHoursAndMinutes = date
      ? formatTime(firestore.Timestamp.fromDate(date))
      : "";
  }

  get date() {
    const selectedDate = this.selectedDate;

    if (!selectedDate) {
      return null;
    }

    const parsedHoursAndMinutes = this.tryParseHoursAndMinutes(
      this.selectedHoursAndMinutes
    );

    if (!parsedHoursAndMinutes) {
      return null;
    }

    const result = new Date(selectedDate);

    result.setHours(parsedHoursAndMinutes.hours);
    result.setMinutes(parsedHoursAndMinutes.minutes);

    return result;
  }

  get formattedSelectedDate() {
    return this.selectedDate ? formatDateShort(this.selectedDate) : "";
  }

  @Watch("selectedDate")
  onSelectedDateChanged() {
    const date = this.date;

    if (date) {
      this.$emit("dateChanged", date);
    }
  }

  @Watch("selectedHoursAndMinutes")
  onSelectedHoursAndMinutesChanged() {
    const date = this.date;

    if (date) {
      this.$emit("dateChanged", date);
    }
  }

  tryParseHoursAndMinutes(input: string) {
    const tokens = input.split(":");

    const firstToken = tokens[0];
    const secondToken = tokens[1];

    let hours = Number(firstToken);
    let minutes = Number(secondToken);

    if (isNaN(hours)) {
      return null;
    }

    let didAdjustHours = false;
    let didAdjustMinutes = false;

    if (hours >= 24) {
      didAdjustHours = true;

      if (isNaN(minutes)) {
        minutes = Math.min(5, hours % 10);
        hours = Math.floor(hours / 10);
        didAdjustMinutes = true;
      } else {
        hours = 23;
      }
    }

    if (!isNaN(minutes) && minutes >= 60) {
      didAdjustMinutes = true;
      minutes = 59;
    }

    if (!isNaN(minutes)) {
      const adjustedInput =
        (didAdjustHours ? (hours < 10 ? `0${hours}` : hours) : firstToken) +
        ":" +
        (didAdjustMinutes ? minutes : secondToken);

      if (adjustedInput != input) {
        this.selectedHoursAndMinutes = adjustedInput;
        return null;
      }
    } else {
      const adjustedInput =
        (didAdjustHours ? hours : firstToken) +
        (input.endsWith(":") ? ":" : "");

      if (adjustedInput != input) {
        this.selectedHoursAndMinutes = adjustedInput;
        return null;
      }
    }

    return {
      hours: hours,
      minutes: isNaN(minutes) ? 0 : minutes,
    };
  }

  get minDateString() {
    return this.minDate ? toDatePickerFormat(this.minDate.toDate()) : "";
  }

  get maxDateString() {
    return this.maxDate ? toDatePickerFormat(this.maxDate.toDate()) : "";
  }

  get datePickerValue() {
    const date = this.selectedDate ?? new Date();
    return toDatePickerFormat(date);
  }
}
